import React, { Component } from 'react';
import _ from 'lodash';
import { Button, Toolbar } from 'react-md';
import '../Wizard.scss';
import Select from 'react-select';
import { ProgressBar } from '../../index';

export default class LotWizardStep extends Component {
  state = {
    initialRelationships: null,
    relationships: null
  }

  componentDidMount() {
    const { data, relationships ,actions: { getOrganizations } } = this.props;
    if (relationships.length < 1) {
      getOrganizations();
    }
    const orgs = data && !!data[0].organizations && data[0].organizations.map((x) => {
      return { value: x.partyKey, label: x.displayName };
    });

    if (data) {

      this.setState({
        initialRelationships: orgs,
        relationships: orgs
      });
    }
  }

  handleOrgChange = (data) => {
    
    this.setState({ relationships: data });
    const formattedData = data.map((x) => {
      return {
        externalKey: x.value,
        displayName: x.label
      };
    });

    this.props.actions.update({
      relationships: formattedData
    });
  }

  handleSubmit = () => {
    const { data, editData, actions, hide } = this.props;
    
    data.map((v, i) => {
      const edits = {
        displayName: editData[i].displayName,
        externalKey: editData[i].externalKey,
        organizations: editData.relationships
      };
      return actions.confirmLot({ original: v, edits });
    });
    hide();
  }

  compareInitialRelationships = () => {
    const { initialRelationships, relationships } = this.state;
    const initialValues = initialRelationships.map(arr => arr.value);
    const updatedValues = relationships.map(arr => arr.value);

    return _.isEqual(initialValues.sort(), updatedValues.sort());
  }

  render() {
    const { options } = this.props;
    const { data, title } = this.props;
    const { relationships } = this.state;
    const displayName = this.props.data && this.props.data.map(v => v.displayName);
    const multipleDisplayNames = displayName && displayName.length > 1;
    const displayNameFormatted = multipleDisplayNames ? displayName.join(', ') : displayName;
    const companySubheader = multipleDisplayNames ? 'These are the companies who manage' : 'This is the company who manages';
    const startedOrphaned = data && !data[0].organizations.length;

    const warningMessage = () => {
      if (relationships) {
        if (relationships.length === 1 && !startedOrphaned) {
          return `If you remove this relationship, you will orphan ${multipleDisplayNames ? 'lots' : 'lot'}: ${displayNameFormatted}`;
        } else if (relationships.length === 0 && !startedOrphaned) {
          return `You are about to remove all relationships to ${multipleDisplayNames ? 'lots' : 'lot'}: ${displayNameFormatted}`;
        }
      }
    }; 

    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: ' 36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" onClick={this.props.hide} icon>arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} steps={1} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">
              {`What organization operates ${multipleDisplayNames ? `these ${displayName.length} lots or garages` : 'this lot or garage'}?`}
            </div>
            <div className="wizard-step-subheader">{`${companySubheader} the parking operations for: ${displayNameFormatted}`}</div>
          </div>
          <div>
            <Select
              classNamePrefix="wizard-select"
              isMulti
              backspaceRemovesValue={false}
              isClearable
              id={`lot-organization-select`}
              className="wizard-select"
              placeholder="Organization"
              value={relationships}
              options={options.lotOperatorOptions}
              onChange={this.handleOrgChange}
            />
          </div>
          <div className="wizard-error">
            {warningMessage()}
          </div>
          <div>
            <Button
              className="wizard-button"
              flat
              disabled={!relationships || !(this.props.editData && this.props.editData.relationships) || this.compareInitialRelationships()}
              onClick={this.handleSubmit}
              children='Confirm Edits'
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/LotWizardStep/LotWizardStep.jsx